import _ from "lodash"
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"

import Client from "data/_client"
import { ApiResult } from "data/interface/api"
import notificationService from "data/notification"
// private module logic //


type CodeCache = {
  [resource: string]: {
    id: number
    code: string
  }
}

const id: string = "codes"
const initialState: ApiResult<CodeCache> = { id, state: "init", value: {} }
const auditLogStream = new BehaviorSubject<ApiResult<CodeCache>>(initialState)

function fetch(resources: string[], propertyid?: number, folderid?: number): Promise<CodeCache | { message: string }> {
  auditLogStream.next({ id, state: 'busy', value: auditLogStream.getValue().value })

  let url = `codes?resources=${resources.join(',')}${propertyid ? `&propertyid=${propertyid}` : ''}${folderid ? `&folderid=${folderid}` : ''}`

  return Client.get(url)
  .then((codes: CodeCache) => {
    auditLogStream.next({ id, state: 'ok', value: codes })
    return codes
  })
  .catch((err: { message: string }) => {
    notificationService.notify({ type: 'danger', message: err.message, dismiss: 5000 })
    return err
  })
}

// public module interface //

const auditLogService = {
  stream: () => auditLogStream.asObservable(),
  value: () => auditLogStream.getValue().value,
  fetch,
}

export default auditLogService

